import { StrictMode, useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { certificationRouter } from "./routes";
import { AuthProvider } from "@/components/layouts/AuthProvider";
import { ThemeSync } from "@/app/lib/theme/ThemeSync";
import { I18nProvider } from "@/app/lib/i18n";

// Own QueryClient instance, same defaults as the main app's (see main.tsx) —
// not shared, since the two apps never mount in the same page load.
const qc = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const CERTIFICATION_DOCUMENT_TITLE = "Lion Energy Certification";

/**
 * Root of the standalone certification app — its own router/route tree,
 * no dashboard chrome. Shares only low-level modules with the main app
 * (auth/session handling, API clients, the ui/ atomic kit), not any
 * navigation or route-tree code. See src/certification-app/routes.tsx.
 */
export function CertificationApp() {
  useEffect(() => {
    document.title = CERTIFICATION_DOCUMENT_TITLE;
  }, []);

  return (
    <StrictMode>
      <QueryClientProvider client={qc}>
        <ThemeSync />
        <AuthProvider>
          <I18nProvider>
            <RouterProvider router={certificationRouter} />
          </I18nProvider>
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>
  );
}
